import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import type { ComponentProps } from 'react';

import translations from './.vocab';

export const CareerFeedBetaBadge = ({
  tone = 'neutral',
}: {
  tone: ComponentProps<typeof Badge>['tone'];
}) => {
  const { t } = useTranslations(translations);
  return <Badge tone={tone}>{t('Beta')}</Badge>;
};
